import React, {Component} from 'react'
import {connect} from 'react-redux'
import {history} from '../../../../store'
import IgniteDataTable from '../../../common/datatable'

class UsersList extends Component {
  constructor(props){
    super(props);
  }

  render() {
    const columns = [
      {prop: 'name', title: 'Name'},
      {prop: 'username', title: 'Username'},
      {prop: 'user-group-name', title: 'Usergroup'},
      {prop: 'status', title: 'Status'},
    ];

    const actions = [
      {
        label: 'Edit',
        permissions: {
          action: 'update',
          subjectClass: 'User'
        },
        render: (cell, row) => {
          return row.attributes.links && row.attributes.links.edit
        },
        callback: (row) => {
          const type = row.attributes.links.edit.indexOf('manage_owners') > 0 ? 'details' : 'edit';
          history.push(`/admin/users/${row.id}/${type}`);
        }
      }
    ];

    const {users, paging} = this.props;

    return (
      <div>
        <IgniteDataTable
          hideId={false}
          data={this.props.users}
          columns={columns}
          actions={actions}
          dataSize={paging ? paging.number * paging.size : users.length}
          pagination={{
            page: this.props.currentPage,
            sizePerPage: 20,
            onPageChange: this.props.onPageChange,
          }}
          remote
        />
      </div>
    )
  }
}

export default connect()(UsersList)


// WEBPACK FOOTER //
// ./src/components/admin/users/list/users-list.jsx